import { removeBackground } from '@imgly/background-removal';

const CACHE_PREFIX = 'bgRemoval:';
const memoryCache = new Map();
const inflight = new Map();

function readCache(url) {
  if (memoryCache.has(url)) return memoryCache.get(url);
  try {
    const hit = sessionStorage.getItem(CACHE_PREFIX + url);
    if (hit) {
      memoryCache.set(url, hit);
      return hit;
    }
  } catch (_) { /* sessionStorage unavailable */ }
  return null;
}

function writeCache(url, dataUrl) {
  memoryCache.set(url, dataUrl);
  try {
    sessionStorage.setItem(CACHE_PREFIX + url, dataUrl);
  } catch (_) { /* quota exceeded — in-memory only */ }
}

function blobToDataUrl(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

export async function removeBackgroundCached(url) {
  if (!url) return null;
  const cached = readCache(url);
  if (cached) return cached;
  if (inflight.has(url)) return inflight.get(url);

  const task = (async () => {
    try {
      const blob = await removeBackground(url);
      const dataUrl = await blobToDataUrl(blob);
      writeCache(url, dataUrl);
      return dataUrl;
    } catch (err) {
      console.warn('[bgRemoval] failed for', url, err);
      return null;
    } finally {
      inflight.delete(url);
    }
  })();

  inflight.set(url, task);
  return task;
}

export default { removeBackgroundCached };
